import { compact, isArray, join, map, some, toString } from 'es-toolkit/compat';
import { AgentStreamAction, AgentStreamProgress, ConversationMessage } from 'interfaces/agentSession';

import { ChatMessage } from './CopilotConversation';

// Some labels arrive as arrays from filter sources; normalize for stable sorting/rendering.
export const normalizeOptionText = (value: unknown): string => {
  if (isArray(value)) {
    return join(
      map(value, (item) => toString(item ?? '')),
      ', '
    );
  }

  return toString(value ?? '');
};

// Keep only user/assistant entries for the chat UI and map server shape to ChatMessage.
export const toChatMessages = (messages: ConversationMessage[]): ChatMessage[] => {
  return compact(
    map(messages, (message) => {
      if (message.role !== 'user' && message.role !== 'assistant') {
        return null;
      }

      return {
        id: message.id,
        role: message.role,
        content: message.content,
        isStreaming: message.status === 'streaming',
        isError: message.status === 'failed',
        tokenTrace: message.tokenTrace,
        followUpOptions: message.followUpOptions,
      } satisfies ChatMessage;
    })
  );
};

export const shouldShowComposerSendingIndicator = ({
  isStreaming,
  messages,
  agentStatus,
  agentProgress,
  agentActions = [],
}: {
  isStreaming: boolean;
  messages: ChatMessage[];
  agentStatus?: string | null;
  agentProgress?: AgentStreamProgress | null;
  agentActions?: AgentStreamAction[];
}): boolean => {
  if (!isStreaming) {
    return false;
  }

  const hasStreamingMessageContent = some(
    messages,
    (message) => message.role === 'assistant' && message.isStreaming && Boolean(message.content.trim())
  );

  return !(Boolean(agentStatus) || Boolean(agentProgress) || agentActions.length > 0 || hasStreamingMessageContent);
};
